import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { useTranslation } from '../hooks';
import { useCatalogFieldSelection } from './hooks/useCatalogFieldSelection';

const StyledWarningBanner = styled(WarningBanner)`
  > * {
    > * {
      &:first-child {
        font-weight: ${({ theme }) => theme.styles.fontWeights.semiBold};
      }
    }
  }
`;

const Text = styled.div`
  font-size: ${({ theme }) => theme.spacing.utils.pxToRem(14)};
  font-weight: ${({ theme }) => theme.styles.fontWeights.regular};
`;

export const CatalogFieldWarningBanner = () => {
  const { t } = useTranslation();
  const { isFieldSelectorDisabled, hasCatalogFieldTypeError } = useCatalogFieldSelection();
  const errorMessage = isFieldSelectorDisabled
    ? t('catalogQuery.warningBannerNoOptions')
    : t('catalogQuery.warningBannerCatalogField');

  if (!hasCatalogFieldTypeError) return null;
  return (
    <StyledWarningBanner title={t('catalogQuery.warningBannerTitle')}>
      <Text>{errorMessage}</Text>
    </StyledWarningBanner>
  );
};
